import React from "react";
import { LaunchModal } from "MODULES/shared/components";
import Edit from "MODULES/Receiving/Detail/EditQuestionsChecklist/Edit";

export default function() {
  return (
    <LaunchModal
      modal={Edit}
      buttonClass="btn-primary btn-hollow pull-right"
      text="Edit"
    />
  );
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/EditQuestionsChecklist/EditButton.jsx